import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import Select from "react-select";

export default class EssenceReferenceReportEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      form: [],
      tree: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;

    let form = [];
    let formQuery = await this.context.api.qa("/report/form/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(formQuery)) {
      formQuery.forEach((item) => {
        form.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    let tree = [];
    let treeQuery = await this.context.api.qa("/report/tree/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(treeQuery)) {
      treeQuery.forEach((item) => {
        tree.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    this.setState(
      {
        form,
        tree,
        editData,
        pending: false,
      },
      () => this.triggerChange()
    );
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({
        form: this.state.editData.form || null,
        tree: this.state.editData.tree || null,
      });
    }
  };

  render() {
    const editData = this.state.editData || {};

    return (
      <>
        <Blocker on={this.state.pending}>
          <div className="form-group">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Форма отчета:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.form,
                      this.state.form
                    )}
                    onChange={(result) => this.onChange("form", result.value)}
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.form}
                    placeholder="Выберите..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Место в структуре:</label>
                  <Select
                    value={this.getReferenceValue(
                      editData.tree,
                      this.state.tree
                    )}
                    onChange={(result) => this.onChange("tree", result.value)}
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.tree}
                    placeholder="Выберите..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
